import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { MarkdownContent } from "@graphiql/react";
/* empty css                       */
const DeprecationReason = (props) => {
  const $ = c(3);
  let t0;
  if ($[0] !== props.children || $[1] !== props.preview) {
    t0 = props.children ? /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-deprecation", children: [
      /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-deprecation-label", children: "Deprecated" }),
      /* @__PURE__ */ jsx(MarkdownContent, { type: "deprecation", onlyShowFirstChild: props.preview ?? true, children: props.children })
    ] }) : null;
    $[0] = props.children;
    $[1] = props.preview;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export {
  DeprecationReason
};
//# sourceMappingURL=deprecation-reason.js.map
